{
  "internalPortal": {
    "components": {
      "locations": {
        "title": "Locations",
        "table": {
          "columns": {
            "number": "Client ID",
            "name": "Name",
            "subsidiaryOrganizationName": "Subsidiary organization name",
            "streetAddress": "Street address",
            "city": "City",
            "state": "State",
            "zip": "ZIP",
            "mainPointOfContact": "Main point of contact",
            "taxId": "Tax ID",
            "squareFootage": "Square footage",
            "weatherStation": "Weather station",
            "hoursOfOperation": "Hours of operation",
            "units": "Units",
            "status": "Status",
            "spendAreas": "Spend areas",
            "stages": "Stages",
            "savings": "Savings",
            "documentFieldStatus": "Document field status",
            "activeAudits": "Active audits",
            "more": "More"
          }
        },
        "actions": {
          "displayLocationsAcrossSubsidiaries": "Display locations across subsidiaries",
          "addLocation": {
            "title": "Add location",
            "tooltip": "Create a single location"
          },
          "template": {
            "title": "Template",
            "tooltip": "Download a template to add multiple new locations"
          },
          "importLocations": {
            "title": "Import locations",
            "tooltip": "Upload a completed template to add multiple new locations"
          }
        },
        "import": {
          "success_one": "You've successfully created {{count}} new location for {{organizationName}}",
          "success_other": "You've successfully created {{count}} new locations for {{organizationName}}"
        },
        "missingFieldsDialog": {
          "title": "Some required fields are missing",
          "content": "Some <highlight>required fields</highlight> (such as client ID, name or address) are <highlight>missing</highlight>. The locations will still be visible in both the Internal Portal and Spend Brain, but they cannot be processed further. Please complete the missing fields. If you don't have this information, create a task for the client to provide it."
        },
        "missingFieldsBanner": {
          "message": "Some <highlight>required fields</highlight> are <highlight>missing</highlight>. Please complete them so the locations can be processed. If you don't have this information, create a task for the client to provide it.",
          "showMissingOnly": "show missing fields only"
        },
        "locationsUploadDialog": {
          "title": "Upload locations",
          "locationFile": "Location file"
        },
        "importDuplicatesDialog": {
          "title": "Duplicate locations found",
          "description_one": "({{count}}) location with the same name, client ID or address already exists in your system",
          "description_other": "({{count}}) locations with the same name, client ID or address already exist in your system",
          "helperText": "<strong>Select</strong> duplicates you want to <strong>add anyway</strong>. Their name or client ID will be adjusted with additional prefix added e.g. (1)",
          "imported": "Imported",
          "existing": "Existing",
          "columns": {
            "number": "Client ID",
            "name": "Name",
            "address": "Address"
          },
          "importSelected": "Import selected ({{count}})",
          "skipAllDuplicates": "Skip all duplicates"
        },
        "deleteDialog": {
          "title_one": "Deleting location",
          "title_other": "Deleting locations",
          "description_one": "Are you sure you want to remove this location? It won't be possible to restore it — you'll need to create or upload it again.",
          "description_other": "Are you sure you want to remove {{count}} locations? It won't be possible to restore them — you'll need to create or upload them again.",
          "notification": {
            "success_one": "You successfully deleted {{count}} location",
            "success_other": "You successfully deleted {{count}} locations",
            "error_one": "Failed to delete location",
            "error_other": "Failed to delete locations"
          }
        },
        "noData": {
          "withFilters": {
            "title": "No locations match your filters",
            "description": "Try adjusting your filters to find what you're looking for"
          },
          "withoutFilters": {
            "title": "No locations found",
            "description": "No locations found, you can create them by clicking the button in the top right corner."
          }
        },
        "locationForm": {
          "create": "Create new location",
          "edit": "Edit location",
          "fields": {
            "address": "Street address",
            "state": "State",
            "city": "City",
            "zip": "ZIP",
            "number": "Client ID",
            "name": "Name",
            "taxId": "Tax ID",
            "status": "Status",
            "savings": "Savings",
            "squareFootage": "Square footage",
            "weatherStation": "Weather station",
            "hoursOfOperation": "Hours of operation",
            "units": "Units",
            "mainPointOfContact": "Main point of contact"
          }
        },
        "bulkEditModal": {
          "description": "Only the fields you enable will be changed. You do not need to fill every field.",
          "selectFields": {
            "title": "Select fields you want to edit",
            "subtitle": "The values you enter will replace the current values on all selected locations."
          },
          "fieldPlaceholder": "Select to update",
          "noFieldsSelected": "Select at least one field to update.",
          "success": "Locations updated successfully",
          "error": "Bulk update failed. Please try again."
        }
      }
    }
  }
}
